export const statusReferrals = {
    CF : "credito_firmado",
    PT : "pago_tiempo",
    PM : "pago_mora",
    EM : "en_mora"
}

export const parsedStatusReferrals = {
    CF : "Crédito firmado",
    PT : "Pagó a tiempo",
    PM : "Pagó en mora",
    EM : "En mora"
}